import uuid from "uuid"
import database from "../firebase/firebase"

// ADD_ACCOUNT
export const addAccount = (account) => ({
  type: "ADD_ACCOUNT",
  account,
})

export const startAddAccount = (accountData = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    const { name = "", role = "", email = "", ref = "", note = "" } = accountData

    const newAccount = { name, role, email, ref, note }
    //console.log('action/accounts: ', newAccount)
    return database
      .ref(`users/${uid}/members`)
      .push(newAccount)
      .then((ref) => {
        dispatch(
          addAccount({
            id: ref.key,
            ...newAccount,
          })
        )
      })
  }
}

// REMOVE_Account
export const removeAccount = ({ id } = {}) => ({
  type: "REMOVE_ACCOUNT",
  id,
})

// EDIT_ACCOUNT
export const editAccount = (id, updates) => ({
  type: "EDIT_ACCOUNT",
  id,
  updates,
})

// db.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle',
//     'location/state': 'Washington'
// })

//startEditLabel
// export const startEditLabel = ((id, updates) => {
//     return (dispatch, getState) => {
//         const uid = getState().auth.uid

//         return database.ref(`users/${uid}/labels/${id}`).update({
//             ...updates
//         })
//             .then(() => {
//                 dispatch(editLabel(id, updates))
//             })
//     }
// })

// course solution
// export const startRemoveLabel = ({ id } = {}) => {
//     console.log('startRemovelabel: ' + id)

//     return (dispatch, getState) => {
//         console.log("startRemoveBefore auth")
//         const uid = getState().auth.uid
//         return database.ref(`users/${uid}/labels/${id}`).remove().then(() => {
//             console.log('dbRemove: startRemovelabel: ' + id)
//             dispatch(removeLabel({ id }));
//         }).catch((e) => {
//             console.log('Remove Error: ', e)
//         });
//     };
//     console.log('startRemovelabelFooter: ' + id)
// };

// SET_LabelS
export const setAccounts = (accounts) => ({
  type: "SET_ACCOUNTS",
  accounts,
})

// export const setPermissions = (permissions) => ({
//   type: "SET_PERMISSIONS",
//   permissions,
// })

const parseResultsToAccounts = (snapshot) => {
  const accounts = []
  snapshot.forEach((child) => {
    accounts.push({
      id: child.key,
      ...child.val(),
    })
  })

  return accounts
}

// const parseResultsToPermissions = (snapshot) => {
//   const permissions = []
//   snapshot.forEach((child) => {
//     accounts.push({
//       id: child.key,
//       ...child.val(),
//     })
//   })

//   return permissions
// }

export const startSetAccounts = () => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    return database
      .ref(`users/${uid}/members`)
      .once("value")
      .then((snapshot) => {
        //console.log(snapshot)
        const accounts = parseResultsToAccounts(snapshot)
        dispatch(setAccounts(accounts))
      })
      .catch((e) => {
        console.log("Fetch Error: ", e)
      })
  }
}

// export const startSetPermissions = () => {
//   return (dispatch, getState) => {
//     const uid = getState().auth.uid
//     return database
//       .ref(`users/${uid}/permissions`)
//       .once("value")
//       .then((snapshot) => {
//         //console.log(snapshot)
//         const permissions = parseResultsToPermissions(snapshot)
//         dispatch(setPermissions(permissions))
//       })
//       .catch((e) => {
//         console.log("Fetch Error: ", e)
//       })
//   }
// }

// export const startAddLabel = (LabelData = {}) => {
//   return (dispatch) => {
//     const {
//       description = '',
//       note = '',
//       amount = 0,
//       createdAt = 0
//     } = LabelData;
//     const Label = { description, note, amount, createdAt };

//     return database.ref('Labels').push(Label).then((ref) => {
//       dispatch(addLabel({
//         id: ref.key,
//         ...Label
//       }));
//     });
//   };
// };



// WEBPACK FOOTER //
// ./src/actions/accounts.js